import { render, staticRenderFns } from "./PaymentInfor.vue?vue&type=template&id=adf7937c&scoped=true&"
import script from "./PaymentInfor.vue?vue&type=script&lang=js&"
export * from "./PaymentInfor.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfor.vue?vue&type=style&index=0&id=adf7937c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf7937c",
  null
  
)

export default component.exports